export enum OrderProfileKeys {
  SLUMP = 'slump',
  SLUMP_TYPE = 'slumpType',
  ADDITIONAL_PRODUCTS = 'additionalProduct',
  KICKER = 'kicker',
  ADDITIONAL_INFO = 'additionalInfo',
  PIPE_QUANTITY = 'pipeQuantity',
  ELEMENT = 'element',
  TIME_PER_LOAD = 'timePerLoad',
  LOAD_SIZE = 'loadSize',
  UNLOAD_TYPE = 'unloadType',
  PUMP_CAPACITY = 'pumpCapacity',
  DISCHARGE_TIME = 'dischargeTime',
  RECCURENCE = 'reccurence',
}
